<div class="all" mat-dialog-content>
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  <h2 class="light-blue-text otsikko">{{ 'lasku.merkitse-osittain-maksetuksi-dialog.merkitse-maksetuksi' | translate | async }}</h2>
  <div class="alaotsikko">{{ 'lasku.merkitse-osittain-maksetuksi-dialog.laskun-tiedot' | translate: { nro: laskunumero, asiakas: asiakkaanNimi, summa: (avoinna | lmoney: kasiteltava.valuutta | async) } | async }}</div>

  <form (ngSubmit)="lisaaMaksettuaSummaa()" novalidate>
    <div class="kentat">
      <mat-form-field>
        <mat-label>{{ 'lasku.merkitse-osittain-maksetuksi-dialog.maksun-maara' | translate | async }}</mat-label>
        <input decimalNumberField matInput #maksettuMaaraInput cdkFocusRegionstart [formField]="lomake.maksettuMaara" />
        <span matSuffix>€</span>
        <mat-error>{{ fieldErrors().maksettuMaara }}</mat-error>
      </mat-form-field>
    </div>
    <div class="avoimeksi-jaa">
      <span>{{ 'lasku.merkitse-osittain-maksetuksi-dialog.avoimeksi-jaa' | translate | async }}</span>
      <span>{{ avoimeksiJaa() | lmoney: kasiteltava.valuutta | async }}</span>
    </div>
    @if (jaaOsittainMaksetuksi()) {
      <div class="vihje">{{ 'lasku.merkitse-osittain-maksetuksi-dialog.osittain-maksettu-vihje' | translate | async }}</div>
    }
  </form>

  <div class="napit">
    <button class="secondarybutton" mat-button mat-dialog-close type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
    <button class="primarybutton" mat-button (click)="lisaaMaksettuaSummaa()" [disabled]="!lomake().valid()" type="button">
      {{ (jaaOsittainMaksetuksi() ? 'lasku.merkitse-osittain-maksetuksi-dialog.kirjaa-osasuoritus' : 'lasku.merkitse-osittain-maksetuksi-dialog.merkitse-maksetuksi') | translate | async }}
    </button>
  </div>
</div>
